export default __webpack_public_path__ + "static/media/permission-crown.6d87cdda.svg";